export default __webpack_public_path__ + "static/media/copy-icon.cfa6a6e5.svg";